import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { AssignmentOptimizerKpiDto, UserTimelines } from '@wilson/interfaces';
import {
  SharedComponentsModule,
  UserDetailsModule,
} from '@wilson/shared-components';
import { TimelineInteractionService } from '@wilson/shift-timeline/services';
import { ShiftTimelineSettingsState } from '@wilson/shift-timeline/state';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { OptimizerAssignmetnsUserKpisComponent } from '../optimizer-assignments-user-kpis/optimizer-assignments-user-kpis.component';
import { TimelineUserDetailsComponent } from '../timeline-user-details/timeline-user-details.component';

@Component({
  selector: 'wilson-user-timelines-draft-info-card',
  templateUrl: './user-timelines-draft-info-card.component.html',
  styleUrls: ['./user-timelines-draft-info-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedComponentsModule,
    NzTooltipModule,
    NzSkeletonModule,
    UserDetailsModule,
    AuthorizationModule,
    FeatureFlagsModule,
    NzDividerModule,
    OptimizerAssignmetnsUserKpisComponent,
    TimelineUserDetailsComponent,
  ],
})
export class UserTimelinesDraftInfoCardComponent {
  timelineInteractionService = inject(TimelineInteractionService);
  private store = inject(Store);

  @Input({ required: true }) user!: UserTimelines;
  @Input() index!: number;
  @Input() isLoadingUserAssignmentKpi = false;
  @Input() userAssignmentKpis: AssignmentOptimizerKpiDto[] | undefined =
    undefined;

  protected defaultRowHeight$ = this.store.select(
    ShiftTimelineSettingsState.defaultRowHeight,
  );
}
